import { useConfig } from '@/hooks/use-data/use-data';

const useLocationConfig = () => {
  return useConfig();
};

export default useLocationConfig;
